/* global mainScript */
import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";

// style rules
import { Sizes } from "../../styles";

import MediaCard from "./MediaCard";

const MediaGrid = ({
	mediaItems,
	pageTitle,
	pageSubtitle,
	pageDescription,
	pdfDownload,
}) => {
	return (
		<Container aria-label="American rivers resources section">
			<Grid>
				<PageInfoContainer>
					{pageSubtitle && <PageSubtitle>{pageSubtitle}</PageSubtitle>}
					{pageTitle && <PageTitle>{pageTitle}</PageTitle>}
					{pageDescription && <p>{pageDescription}</p>}
					{pdfDownload && (
						<DownloadButton href={pdfDownload} className="button" download>
							Download the PDF
						</DownloadButton>
					)}
					<SharingSteps>
						<h3>Instructions</h3>
						<ol>
							<li>Click on the social media platform you wish to upload to</li>
							<li>
								The post text will be copied to your clipboard once a social
								media icon is clicked.
							</li>
							<li> The media file will start downloading and you will be redirected to the social media
							platform selected.</li>
							<li>Upload the media file from your device.</li>
							<li>Paste the text: <b>⌘ / Ctrl + V</b></li>
						</ol>
					</SharingSteps>
				</PageInfoContainer>
				{mediaItems.map((item, index) => {
					return <MediaCard key={index} resource={item} />;
				})}
			</Grid>
		</Container>
	);
};

MediaGrid.propTypes = {
	mediaItems: PropTypes.array,
	mediaPageInfo: PropTypes.array,
	pageTitle: PropTypes.string,
	pageSubtitle: PropTypes.string,
	pageDescription: PropTypes.string,
	pdfDownload: PropTypes.string,
};

export default MediaGrid;

const Container = styled.div`
	padding: 0 0 8rem 0;
`;

const Grid = styled.ul`
	display: ${(props) => (props.isEmpty ? "block" : "grid")};
	grid-template-columns: 1fr;
	gap: 2.5rem;
	margin: 0;
	padding: 0;
	max-width: unset;

	@media only screen and (min-width: ${Sizes.screens.medium}) {
		grid-template-columns: 1fr 1fr 1fr;
		grid-template-rows: repeat(autofill, minmax(0, 33.2rem));
		column-gap: 4.4rem;
		row-gap: 10.8rem;
	}
`;

const PageInfoContainer = styled.div`
	margin-bottom: 4rem;

		@media only screen and (min-width: ${Sizes.screens.medium}) {
			margin-right: 0.9rem;
			margin-bottom: 0;
	}
`;

const PageSubtitle = styled.h1`
	font-size: 2.4rem;
	line-height: 3.4rem;
	letter-spacing: 0.72px;
`;

const PageTitle = styled.h2`
	margin-bottom: 2rem;
`;
const DownloadButton = styled.a`
	margin-top: 4rem;
	display: flex;
	align-items: center;
	gap: 0.7rem;
	max-width: fit-content;

	&::before {
		content: url(${mainScript.assetPath +
		"images/svg/icons/icon-download.svg"});
		width: 2.4rem;
		height: 2.4rem;
	}
`;

const SharingSteps = styled.div`
	> h3 {
		margin-top: 4rem;
		margin-bottom: 2rem;
		font-size: 1.8rem;
		line-height: 2.8rem;

		@media only screen and (min-width: ${Sizes.screens.large}) {
			font-size: 2rem;
			line-height: 3rem;
		}
	}

	> ol {
		padding-left: 2rem;
		padding-right: 0;
		padding-bottom: 0;

		@media only screen and (min-width: $screen-medium) {
			padding-left: 4rem;
		}
		> li {
			font-size: 1.4rem;
			line-height: 2rem;
			text-indent: 0.3rem;
		}
	}
`;
